// SYSTEM1
import { toaster } from "@/utilities/toaster";
import { assign, Machine } from "xstate";
import { PAReviewModule } from "@/store/modules/paReview.module";
const paReviewMeetingMachine = Machine({
    id: "paReviewMeetingMachine",
    context: {
        reviewId: "",
        meetingId: "",
    },
    initial: "idle",
    states: {
        idle: {
            on: {
                GETTING_REVIEW_MEETING: { target: "getReviewMeeting", actions: "assignReviewId" },
            },
        },
        getReviewMeeting: {
            tags: "getReviewMeeting",
            invoke: {
                id: "getReviewMeeting",
                src: (context, event) => {
                    return PAReviewModule.GetReviewMeeting(context.reviewId);
                },
                onDone: [
                    {
                        target: "loadedReviewMeeting.scheduleReviewMeeting",
                        cond: () => !PAReviewModule.isMeetingCreated,
                    },
                    {
                        target: "loadedReviewMeeting.reviewMeetingDetails",
                    },
                ],
                onError: { target: "serviceUnavailable" },
            },
        },
        loadedReviewMeeting: {
            states: {
                scheduleReviewMeeting: {
                    tags: "scheduleMeeting",
                    on: {
                        SCHEDULE_MEETING: { target: "#paReviewMeetingMachine.loadedReviewMeeting.startMeeting" },
                    },
                },
                startMeeting: {
                    tags: ["upsertMeeting"],
                    on: {
                        CANCEL: { target: "#paReviewMeetingMachine.loadedReviewMeeting.scheduleReviewMeeting" },
                        NOTIFY_DETAIL_COMPONENT: { target: "#paReviewMeetingMachine.loadedReviewMeeting.reviewMeetingDetails" },
                    },
                },
                reviewMeetingDetails: {
                    tags: "showReviewDetailUI",
                    on: {
                        EDIT_MEETING: { target: "#paReviewMeetingMachine.loadedReviewMeeting.startMeeting", actions: "assignMeetingId" },
                        INITIALIZE: { target: "#paReviewMeetingMachine.getReviewMeeting", actions: "assignReviewId" },
                    },
                },
            },
        },
        serviceUnavailable: {
            type: "final",
        },
    },
}, {
    actions: {
        showSuccessMessage: (context, event) => {
            toaster.ShowSuccess(event.data.successMessages[0]);
        },
        assignReviewId: assign({
            reviewId: (ctx, event) => {
                return event.reviewId;
            },
        }),
        assignMeetingId: assign({
            meetingId: (ctx, event) => {
                return event.meetingId;
            },
        }),
    },
    guards: {},
    activities: {},
    services: {},
});
export default paReviewMeetingMachine;
